/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const VIEW_TAB = 'VIEW_TAB';
export const VIEW_ERROR_MSG = 'VIEW_ERROR_MSG';
export const VIEW_FIELD_ERR = 'VIEW_FIELD_ERR';
export const REBATE_PGM_DETAIL = 'REBATE_PGM_DETAIL';
export const DEFAULT_AUDIT = 'DEFAULT_AUDIT';
export const ENABLE_SAVE = 'ENABLE_SAVE';
export const COMMENTS_FLAG = 'COMMENTS_FLAG';
export const COPY_DATA = 'COPY_DATA';
export const URA_GRID_DATA = 'URA_GRID_DATA';
export const COPY_URA_GRID_DATA = 'COPY_URA_GRID_DATA';
export const LAST_FROZEN_QTR = 'LAST_FROZEN_QTR';
export const LAST_URA_SRC_CALC_QTR = 'LAST_URA_SRC_CALC_QTR';
export const INT_GRID_DATA = 'INT_GRID_DATA';
export const COPY_INT_GRID_DATA = 'COPY_INT_GRID_DATA';
export const AUDIT_GRID_DATA = 'AUDIT_GRID_DATA';
export const COPY_AUDIT_GRID_DATA = 'COPY_AUDIT_GRID_DATA';
export const OVERRIDR_DATA = 'OVERRIDE_DATA';
export const UNIT_TYPE_AUDIT_GRID_DATA = 'UNIT_TYPE_AUDIT_GRID_DATA';
export const COPY_UNIT_TYPE_DATA = 'COPY_UNIT_TYPE_DATA';
export const GROUP_GRID_DATA = 'GROUP_GRID_DATA';
export const COPY_GROUP_GRID_DATA = 'COPY_GROUP_GRID_DATA';
export const ENROLL_GRID_DATA = 'ENROLL_GRID_DATA';
export const COPY_ENROLL_GRID_DATA = 'COPY_ENROLL_GRID_DATA';
export const DELETED_URA_SOURCE = 'DELETED_URA_SOURCE';
export const DELETED_URA_CALC = 'DELETED_URA_CALC';
export const DELETED_URA_PAY = 'DELETED_URA_PAY';
export const DELETED_INT_CALC = 'DELETED_INT_CALC';
export const DELETED_INT_FED = 'DELETED_INT_FED';
export const DELETED_INT_FED_FMLY = 'DELETED_INT_FED_FMLY';
export const RESET_STORE = 'RESET_STORE';
export const CUSTOM_RESET = 'CUSTOM_RESET';
export const DELETED_CMS_RPT = 'DELETED_CME_RPT';
export const DELETED_CMS_UTIL = 'DELETED_CMS_UTIL';
export const DELETED_ENROLL = 'DELETED_ENROLL';
export const CMS_FREEZE_QTR = 'CMS_FREEZE_QTR';
export const MAX_ENROLL_QTR = 'MAX_ENROLL_QTR';
export const USE_DEF_AUDIT = 'USE_DEF_AUDIT';
export const DEFAULT_OVERRIDE_DATA = 'DEFAULT_OVERRIDE_DATA';
export const SYSTEM_OVERRIDE_DATA = 'SYSTEM_OVERRIDE_DATA';
export const CONS_AUDIT_DATA = 'CONS_AUDIT_DATA';
export const SAVE_INFO = 'SAVE_INFO';
export const MAINTAINRBT_REDUX_CLEAR = 'MAINTAINRBT_REDUX_CLEAR';
